import jwtDecode from 'jwt-decode';

// Verifie si le token est expiré
export const isTokenExpired = () => {
  const token = localStorage.getItem('token');

  return !token || jwtDecode(token).exp < Date.now() / 1000;
};

